var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-company-info-wrapper",
    { attrs: { company: _vm.company, "no-scroll": "" } },
    [
      _c(
        "w-row",
        { attrs: { center: "", shrink: "" } },
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c(
                "w-scroll-view",
                { style: { height: "100%" }, attrs: { tag: "w-card" } },
                [
                  _c(
                    "w-list",
                    [
                      _c(
                        "w-list-item",
                        [
                          _c("w-list-item-text", [_vm._v("id")]),
                          _c("w-list-item-text", [_vm._v("start date")]),
                          _c("w-list-item-text", [_vm._v("end date")]),
                          _c("w-list-item-text", [_vm._v("next payment date")]),
                          _c("w-list-item-text", [_vm._v("status")]),
                          _c("w-list-item-text"),
                          _c(
                            "w-list-item-text",
                            { staticClass: "right-align" },
                            [_vm._v(" price ")]
                          ),
                          _c("w-list-item-action"),
                        ],
                        1
                      ),
                      _vm._l(_vm.subscriptions, function (sub) {
                        return _c(
                          "w-list-item",
                          { key: sub.id },
                          [
                            _c("w-list-item-text", [_vm._v(_vm._s(sub.id))]),
                            _c("w-list-item-text", [
                              _vm._v(
                                _vm._s(_vm._f("dateString")(sub.startDate))
                              ),
                            ]),
                            _c("w-list-item-text", [
                              _vm._v(_vm._s(_vm._f("dateString")(sub.endDate))),
                            ]),
                            _c("w-list-item-text", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("dateString")(sub.nextPaymentDate)
                                )
                              ),
                            ]),
                            _c("w-list-item-text", [
                              _vm._v(_vm._s(sub.status)),
                            ]),
                            _c(
                              "w-list-item-text",
                              [
                                _c(
                                  "w-link",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.showPlan(sub)
                                      },
                                    },
                                  },
                                  [_vm._v(" show plan ")]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "w-list-item-text",
                              { staticClass: "right-align" },
                              [
                                _vm._v(
                                  " €" +
                                    _vm._s(_vm._f("humanFloat")(sub.price)) +
                                    " "
                                ),
                              ]
                            ),
                            _c("w-list-item-action"),
                          ],
                          1
                        )
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          attrs: { value: _vm.shownSubscription != null, "escape-close": "" },
          on: {
            input: function ($event) {
              _vm.shownSubscription = null
            },
          },
        },
        [
          _vm.shownSubscription
            ? _c("app-company-plan", {
                attrs: { "plan-metadata": _vm.shownSubscription },
                on: {
                  close: function ($event) {
                    _vm.shownSubscription = null
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }